const DataFilter_view3 = (thaiData, selectedYear, selectedMonth, selectedTimeFormat,selectedAge, selectedGender, view, streamReady) => {

    let dataFilter = null;
    let dataFilter_gender = null;
    let dataFilter_all = null;

    if(thaiData!=null){
        let dataSelect = {};

        if(streamReady){
            if(view === 3){
                dataSelect = {
                    'view_3_month_gender_age': thaiData[0].view_3_month_gender_age,
                    'view_3_week_gender_age': thaiData[1].view_3_week_gender_age,
                    'view_3_year_gender_age': thaiData[2].view_3_year_gender_age,
                    'view_3_month_age': thaiData[3].view_3_month_age,
                    'view_3_week_age': thaiData[4].view_3_week_age,
                    'view_3_year_age': thaiData[5].view_3_year_age
                };
            }
        } 
        let dataFilter;

        const genderFilter = (dataFilter, gender) => {
            let i = 0;
            const dataByGender = dataFilter.filter(function (data) {
                for(i=0;i<gender.length;i++){
                    if(data.SEX.includes(gender[i])){
                        return data; 
                    }
                }
              });
            return dataByGender;
        }

        const ageFilter = (dataFilter, age) => {
            let i = 0;
            const dataByAge = dataFilter.filter(function (data) {
                for(i=0;i<age.length;i++){
                    if(data.AGE_GROUP === age[i].value){
                        return data; 
                    }
                }
              });
            return dataByAge;
        }

        const yearFilter = (dataFilter, year, month) => {

            const dataByYear = dataFilter.filter(function (data) {
                if (data.Date.includes(year) && parseInt(data.DMON) >= month){
                    return true
                } else if (data.Date.includes(year+1)){
                    return true
                } else if (month > 1 && data.Date.includes(year+2) && parseInt(data.DMON) <= month){
                    return true
                } else {
                    return false
                }
              });
            return dataByYear;
        }

        const filter_by_cond = (dataFilter) => {
            if( view === 3 ){
                if(selectedGender != null && selectedAge != null){
                        if(selectedGender.length != 0 && selectedAge.length != 0){
                            if(!(selectedGender.includes('รวม'))){
                                if(selectedTimeFormat === 'เดือน' ){
                                    dataFilter = yearFilter(dataSelect.view_3_month_gender_age, selectedYear, selectedMonth);
                                    dataFilter = genderFilter(dataFilter, selectedGender);
                                    dataFilter = ageFilter(dataFilter,  selectedAge);
                                } else if (selectedTimeFormat === 'สัปดาห์' ){
                                    dataFilter = yearFilter(dataSelect.view_3_week_gender_age, selectedYear, selectedMonth);
                                    dataFilter = genderFilter(dataFilter, selectedGender);
                                    dataFilter = ageFilter(dataFilter,  selectedAge);
                                } else if (selectedTimeFormat === 'ปี' ){
                                    dataFilter = genderFilter(dataSelect.view_3_year_gender_age, selectedGender);
                                    dataFilter = ageFilter(dataFilter,  selectedAge);
                                } 
                            } else if (selectedGender.includes('รวม') && selectedGender.length === 1){
                                if (selectedTimeFormat === 'เดือน' ){
                                    dataFilter = yearFilter(dataSelect.view_3_month_age, selectedYear, selectedMonth);
                                    dataFilter = ageFilter(dataFilter,  selectedAge);
                                } else if (selectedTimeFormat === 'สัปดาห์' ){
                                    dataFilter = yearFilter(dataSelect.view_3_week_age, selectedYear, selectedMonth);
                                    dataFilter = ageFilter(dataFilter,  selectedAge);
                                } else if (selectedTimeFormat === 'ปี' ){
                                    dataFilter = ageFilter(dataSelect.view_3_year_age,  selectedAge);
                                } 
                            } else if (selectedGender.includes('รวม') && selectedGender.length > 1){
                                if(selectedTimeFormat === 'เดือน' ){
                                    //gender
                                    dataFilter_gender = yearFilter(dataSelect.view_3_month_gender_age, selectedYear, selectedMonth);
                                    dataFilter_gender = genderFilter(dataFilter_gender, selectedGender);
                                    dataFilter_gender = ageFilter(dataFilter_gender,  selectedAge);

                                    // all
                                    dataFilter_all = yearFilter(dataSelect.view_3_month_age, selectedYear, selectedMonth);
                                    dataFilter_all = ageFilter(dataFilter_all,  selectedAge);

                                    dataFilter = dataFilter_gender.concat(dataFilter_all);
                                } else if (selectedTimeFormat === 'สัปดาห์' ){
                                    //gender
                                    dataFilter_gender = yearFilter(dataSelect.view_3_week_gender_age, selectedYear, selectedMonth);
                                    dataFilter_gender = genderFilter(dataFilter_gender, selectedGender);
                                    dataFilter_gender = ageFilter(dataFilter_gender,  selectedAge);

                                    //all
                                    dataFilter_all = yearFilter(dataSelect.view_3_week_age, selectedYear, selectedMonth);
                                    dataFilter_all = ageFilter(dataFilter_all,  selectedAge);

                                    dataFilter = dataFilter_gender.concat(dataFilter_all);

                                } else if (selectedTimeFormat === 'ปี' ){
                                    //gender
                                    dataFilter_gender = genderFilter(dataSelect.view_3_year_gender_age, selectedGender);
                                    dataFilter_gender = ageFilter(dataFilter_gender,  selectedAge);
                                    
                                    //all
                                    dataFilter_all = ageFilter(dataSelect.view_3_year_age,  selectedAge);

                                    dataFilter = dataFilter_gender.concat(dataFilter_all);
                                }
                            }
                    }
                }
            }  

            return {dataFilter};
        }

        dataFilter = filter_by_cond(dataFilter);
        if(dataFilter.dataFilter != undefined){
            if(dataFilter.dataFilter.length != 0){
                let dataFilterTemp = [...dataFilter.dataFilter ];
                dataFilterTemp = dataFilterTemp.sort((a, b) => a.engDate - b.engDate);
                dataFilterTemp = dataFilterTemp.sort(function (a, b) {
                    if(a.SEX === undefined){
                        return 1;
                    } else {
                        return  b.SEX ? a.SEX.localeCompare(b.SEX) : -1;  
                    }    
               });
               dataFilter.dataFilter = dataFilterTemp.sort(function (a, b) {
                    return  b.AGE_GROUP ? a.AGE_GROUP.localeCompare(b.AGE_GROUP) : -1;          
                });
            }
        }
        return dataFilter;
    
    }

    return {dataFilter};
}
 
export default DataFilter_view3;